module.exports = __webpack_public_path__ + "static/media/IMAGE-4-SILAGE-PLASTIC-desktop.0be3eeb8.jpg";